/**
 * Firebase Configuration
 * ──────────────────────
 * Safety Bible §1: All secrets in Vercel env vars.
 * Client-side Firebase config is safe to expose (publishable keys).
 * Server-side operations use FIREBASE_SERVICE_ACCOUNT env var.
 *
 * In dev mode without Firebase credentials, the app runs in
 * mock mode — auth returns null, Firestore is unavailable.
 */
import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'demo.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'demo-project',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
};

export const isDemoMode = !import.meta.env.VITE_FIREBASE_API_KEY;

// Initialize only once (avoid duplicate app errors in HMR)
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0]!;
}

auth = getAuth(app);
db = getFirestore(app);

export { app, auth, db };
